import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { UserName } from '../../UserName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InstalledByRow({
  installedInfo,
  onUninstallClick
}) {
  var _installedInfo$firstN, _installedInfo$lastNa, _installedInfo$email;
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(UserName, {
        user: {
          id: installedInfo.userId,
          firstName: (_installedInfo$firstN = installedInfo.firstName) !== null && _installedInfo$firstN !== void 0 ? _installedInfo$firstN : '',
          lastName: (_installedInfo$lastNa = installedInfo.lastName) !== null && _installedInfo$lastNa !== void 0 ? _installedInfo$lastNa : '',
          email: (_installedInfo$email = installedInfo.email) !== null && _installedInfo$email !== void 0 ? _installedInfo$email : ''
        }
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(FormattedDateTime, {
        format: "ll LT",
        value: installedInfo.installedAt
      })
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: onUninstallClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.installedBy.table.uninstall"
        })
      })
    })]
  });
}